import { render, staticRenderFns } from "./DescargarExcel.vue?vue&type=template&id=5a0456f9&"
import script from "./DescargarExcel.vue?vue&type=script&lang=js&"
export * from "./DescargarExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports